/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AppEnvironment {
    None = 0,
    Dev = 1,
    Prod = 2,
    Demo = 3,
    QA = 4,
    Dynamic = 5,
}
